import {
    StyleSheet
} from "react-native";
import type {
    NavigationMenuContentDynamicStyleType
} from "./type";

export const NAVIGATION_MENU_SKELETON_ROWS: Array<string> = [
    "first",
    "second",
    "third"
];

const stylesheet = StyleSheet.create({
    skeletonRow: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    skeleton: {
        flexDirection: "column",
        minWidth: 0,
        flex: 1
    },
    skeletonText: {
        flexDirection: "column",
        minWidth: 0,
        flex: 1
    },
    sheetContent: {
        flexDirection: "column"
    },
    tracks: {
        flexDirection: "row",
        alignItems: "stretch"
    }
});

export const useStyles = ({
    isFullWidth,
    spaces
}: NavigationMenuContentDynamicStyleType) => {
    return {
        tracks: {
            gap: isFullWidth ? spaces.spacingLg : spaces.spacingXs
        },
        skeletonRow: {
            padding: spaces.spacingSm,
            gap: spaces.spacingSm
        },
        skeletonText: {
            gap: spaces.spacingXxs
        }
    };
};
export default stylesheet;
